// example html:
// <select class="js-select-binding" data-url="/api/v1/select-binding" data-target=".js-select-binding-target" data-selected="1" data-no-blank="true">
//   <option value="">Select</option>
// </select>
// <select class="js-select-binding-target" data-selected="2">
//   <option value="">Select</option>
// </select>
export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    const toggleBtns = document.querySelectorAll('.js-select-binding')

    for (let i = 0; i < toggleBtns.length; i++) {
      const dom = toggleBtns[i]
      let collection = null
      const url = dom.dataset.url
      const init_collection = function (dom, collection) {
        if (typeof collection === 'object') {
          collection = Object.values(collection)
        }
        const target_select = document.querySelector(dom.dataset.target)
        // set collection to dom
        const selected_value = dom.dataset.selected
        if (dom.dataset.noBlank) {
          dom.innerHTML = ''
        }
        dom.innerHTML =
          dom.innerHTML +
          collection
            .map(
              (item) =>
                `<option value="${item.id}" ${
                  selected_value === item.id ? 'selected' : ''
                }>${item.name}</option>`
            )
            .join('')
        const change_handler = function () {
          target_select.innerHTML = ''
          const target_options = collection
            .filter((item) => item.id + '' === dom.value + '')
            .map((item) => Object.values(item.children))
            .flat()
          if (target_options.length > 0) {
            const target_selected_value = target_select.dataset.selected
            target_options.forEach((option) => {
              target_select.innerHTML += `<option value="${option.id}" ${
                target_selected_value === option.value ? 'selected' : ''
              }>${option.name}</option>`
            })
          } else {
            target_select.innerHTML = ''
          }
        }
        if (typeof $ !== 'undefined') {
          $(dom).on('change', change_handler) // eslint-disable-line no-undef
        } else {
          dom.addEventListener('change', change_handler)
        }
        if (selected_value) {
          change_handler()
        }
      }
      if (url) {
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            collection = data
            init_collection(dom, collection)
          })
          .catch(function (error) {
            console.error('Error:', error)
          })
      }
    }
  })
})()
